import React, { useState, useEffect } from 'react';
import Head from 'next/head';
import styles from './styles.module.css';
import BannerHorizontalChico from '@/widgets/Banner/Templates/BannerHorizontalChico';
import { PagegrowlerFunctions } from "@pagegrowler_nextjs";
import {
  ArrowRight,
  ArrowLeft
} from '@/icons/index'

const ImgCarousel = (props) => {

  const {
    images,
    title,
    url,
    summary = ''
  } = props;
  
  const CLIPPING_FIRST = "2_1_1300x655";
  const pagegrowlerFunctions = PagegrowlerFunctions();

  const quantity = images?.length
  const [sliderIndex, setSliderIndex] = useState(0);
  let imgList = [];

  const setImg = (element, clipping) => {
    let elementImg = {
      images: [
        element.value &&
        {
          clippings: element.value.clippings || [],
          title: element.value.title || ''
        }
      ]
    };
    return pagegrowlerFunctions.getFullImageObject(elementImg, clipping, process.env.NEXT_PUBLIC_IMAGE_DOMAIN);
  };

  imgList = images.map(el => {
    let img = setImg(el, CLIPPING_FIRST);
    return {
      img: img.url ? img.url : '',
      author: el.author ? el.author : '',
      epigraphe: el.epigraphe ? el.epigraphe : '',
      title: el.value.title ? el.value.title : '',
    };
  });

  const actionNext = (event) => {
    if (event) {
      event.stopPropagation();
    }
    setSliderIndex((prevIndex) => (prevIndex + 1) % quantity);
  };

  const actionPrev = (event) => {
    if (event) {
      event.stopPropagation();
    }
    setSliderIndex((prevIndex) => (prevIndex - 1 + quantity) % quantity);
  };

  return (
    <>
      {imgList[0]?.img && (
        <Head>
          <link rel="preload" href={imgList[0].img} as="image" fetchpriority="high" />
        </Head>
      )}
      <div className={`${styles['gallery-container']}`}>
        <div className={`${styles['slider']}`}>
          {sliderIndex > -1 && (
            <a href={url} className={`${styles['img-link']}`}>
              <img
                className={`${styles['slider-img']}`}
                src={imgList[sliderIndex]?.img}
                alt={imgList[sliderIndex]?.title}
                width={1300}
                height={655}
                fetchpriority={sliderIndex === 0 ? 'high' : undefined}
              />
            </a>
          )}

          {sliderIndex > -1 && (
            <div className={`${styles['arrows-container']}`}>
              <div className={`${styles['arrows-content']}`}>
                <button type="button" onClick={actionPrev} className={`${styles['arrows-left']} ${styles['arrows']}`}>
                  <ArrowLeft className={`${styles['icon']}`} />
                </button>
                <button type="button" onClick={actionNext} className={`${styles['arrows-right']} ${styles['arrows']}`}>
                  <ArrowRight className={`${styles['icon']}`} />
                </button>
              </div>
            </div>
          )}

          <a href={url} className={`${styles['description-container']}`}>
            {imgList[sliderIndex]?.epigraphe &&
              <>
                <h3>{imgList[sliderIndex]?.epigraphe} {imgList[sliderIndex]?.author && <strong>Foto: {imgList[sliderIndex]?.author}</strong>} </h3>
                <div className={`${styles['img-counter']}`}>{sliderIndex + 1} de {quantity}</div>
              </>
            }
          </a>

        </div>
      
        <div className={`${styles['title-container']}`}>
        <a href={url}>
          {summary && summary !== '' ? <h2 className={styles["summary"]}>{summary}</h2> : null}
          {title && title !== '' ? <h2 className={`${styles['title']}`} >{title}</h2> : null}
          {quantity && quantity !== '' ? <span className={`${styles['subtitle']}`}>{quantity} Fotos</span> : null}</a>
        </div>
      </div>

      {!props.preview && <BannerHorizontalChico bannerId={`top`} />}


    </>
  )
}

export default ImgCarousel;
